"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactTable = require("@tanstack/react-table");
var _BaseColumn = require("./support/BaseColumn");
var _BaseButton = _interopRequireWildcard(require("../../../controls/buttons/BaseButton"));
var _DropdownList = _interopRequireDefault(require("../../../controls/dropdown/DropdownList"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Cell = require("../cell/Cell.styled");
var _tokens = _interopRequireDefault(require("../../../../shared/tokens/tokens"));
var _jsxRuntime = require("react/jsx-runtime");
var ActionDropdownButton = (0, _styledComponents.default)(_BaseButton.default).withConfig({
  displayName: "ActionColumn__ActionDropdownButton",
  componentId: "sc-nejzsx-0"
})(["background-color:transparent;.left-icon svg path{fill:", ";}&:hover,&.focus-ring{background-color:", ";.left-icon svg path{fill:", ";}}"], _tokens.default.sky.sys.color.iconfill.onlight, _tokens.default.sky.sys.color.background.neutral['1'], _tokens.default.sky.sys.color.iconfill.onlight);
var Option = function Option(_) {
  return null;
};
var ActionColumn = function ActionColumn(_) {
  return null;
};
var columnHelper = (0, _reactTable.createColumnHelper)();
var isHidden = function isHidden(child, row) {
  var hidden = child.props.hidden;
  return typeof hidden === 'function' ? hidden(row.original) : !!hidden;
};
var isDisabled = function isDisabled(child, row) {
  var disabled = child.props.disabled;
  return typeof disabled === 'function' ? disabled(row.original) : !!disabled;
};
ActionColumn.toColumnDef = function (child) {
  var _child$props = child.props,
    header = _child$props.header,
    hideHeader = _child$props.hideHeader;
  return columnHelper.display({
    meta: {
      header: header,
      hideHeader: hideHeader,
      width: '78px',
      excludeFromExport: true
    },
    header: hideHeader ? undefined : (0, _BaseColumn.defaultHeader)(child.props),
    id: 'actions',
    cell: function cell(_ref) {
      var row = _ref.row;
      var isCellHidden = isHidden(child, row);
      return row.getIsGrouped() || isCellHidden ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Cell.StyledCell, {
        align: child.props.align,
        narrow: true,
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_DropdownList.default, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_DropdownList.default.Trigger, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ActionDropdownButton, {
              iconOnly: true,
              noMargin: true,
              emphasis: _BaseButton.EMPHASIS.LOW,
              leftIcon: 'more',
              "data-cy": 'actions'
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_DropdownList.default.Content, {
            offset: 4,
            children: _react.default.Children.map(child.props.children, function (child) {
              var isOptionHidden = isHidden(child, row);
              if (!isOptionHidden) {
                var disabled = isDisabled(child, row);
                var dataCy = child.props['data-cy'];
                return /*#__PURE__*/(0, _jsxRuntime.jsx)(_DropdownList.default.Item, {
                  "data-cy": dataCy,
                  disabled: disabled,
                  onClick: function onClick() {
                    return child.props.onClick(row.original);
                  },
                  children: child.props.children
                });
              } else {
                return null;
              }
            })
          })]
        })
      });
    }
  });
};
ActionColumn.Option = Option;
var _default = exports.default = ActionColumn;